
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const LockIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 21H7a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 17.09V14.5M12.53 13.22a.75.75 0 1 1-1.06 1.06.75.75 0 0 1 1.06-1.06M8 9V7v0a4 4 0 0 1 4-4v0a4 4 0 0 1 4 4v2"/></svg>
  </SvgIcon>
);
